import React from 'react';
import { useMedicalProfileFileAudio } from '../../../hooks/api/useMedicalProfileFileAudio';
import AudioPlayer, { RenderTranscript } from './AudioPlayer';
import Stack from '../../v2BaseComponents/Stack';
import Skeleton from '../../v2BaseComponents/Skeleton';
import { useAudioDuration } from './useAudioDuration';

export type MedicalProfileFileAudioPlayerOwnProps = {
    medicalProfileId: string;
    medicalProfileFileId: string;
    startTime?: number;
    endTime?: number;
    renderTranscript?: RenderTranscript;
};

export type MedicalProfileFileAudioPlayerProps = MedicalProfileFileAudioPlayerOwnProps;

const MedicalProfileFileAudioPlayer: React.FC<MedicalProfileFileAudioPlayerProps> = ({
    medicalProfileId,
    medicalProfileFileId,
    startTime,
    endTime,
    renderTranscript,
}) => {
    const { status, audio } = useMedicalProfileFileAudio({
        medicalProfileId,
        medicalProfileFileId,
    });

    const audioDuration = useAudioDuration(audio?.downloadUrl || null, audio?.transcript || null);

    if (status === 'loading' || audioDuration === null) {
        return (
            <>
                <Stack horizontal fullWidth justify="center" align="center" style={{ height: 76 }}>
                    <Skeleton style={{ width: '100%', height: '100%' }} />
                </Stack>
                {audio?.transcript
                    ? renderTranscript?.({
                          isLoading: false,
                          position: null,
                          transcript: audio.transcript,
                          isPlaying: false,
                      })
                    : renderTranscript?.({ isLoading: true }) || null}
            </>
        );
    } else if (status === 'loaded' && audio) {
        return (
            <AudioPlayer
                audioUrl={audio.downloadUrl}
                startTime={startTime}
                endTime={endTime}
                renderTranscript={renderTranscript}
                transcript={audio.transcript || undefined}
                duration={audioDuration}
            />
        );
    } else {
        return null;
    }
};

export default React.memo(MedicalProfileFileAudioPlayer);
